import React from 'react';
import { TComponentCategory } from '../types';
import { Box, Checkbox, IconButton, Typography } from '@mui/material';
import StyledPaper from './StyledPaper';
import AddOutlinedIcon from '@mui/icons-material/AddOutlined';
import RemoveOutlinedIcon from '@mui/icons-material/RemoveOutlined';
import lodash from 'lodash';
import PriceRender from './PriceRender';
import StyledRadio from './StyledRadio';
import { t } from '@lingui/macro';

const ItemComponentsByCategory: React.FC<
    { componentsCategories: TComponentCategory[], onComponentChange: (change: TComponentCategory) => void }
> = (props) => {
    const { componentsCategories, onComponentChange } = props

    return <Box>
        {componentsCategories.map(category => <Box>
            <Box mb={'12px'} display={'flex'} alignItems={'center'}>
                <Typography mr={'8px'} color={'#666687'}>{category.name}</Typography>
                {category.maxSelected > 1
                    && category.componentType === 'multiple'
                    && category.options[0].maxValue < 2
                    && <Typography fontSize={14} mb={'-2px'} color={'#666687'}>{t`(max ${category.maxSelected})`}</Typography>}
            </Box>
            {category.options.map((option, index) =>
                <StyledPaper
                    key={option.name}
                    sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center', height: '48px', mb: '12px', p: 0 }}
                >
                    <>{category.componentType === 'single'
                        ? <Box
                            display='flex'
                            alignItems='center'
                            justifyContent='space-between'
                            flexGrow={1}
                            onClick={() => {
                                const newComponent = lodash.cloneDeep(category)
                                newComponent.options = category.options.map(option => ({ ...option, value: 0 }))
                                newComponent.options.splice(index, 1, {
                                    ...option,
                                    value: option.value === 1 ? 0 : 1
                                })
                                onComponentChange(newComponent)
                            }} >
                            <Box
                                display='flex'
                                alignItems='center'>
                                <StyledRadio checked={option.value === 1} />
                                <Typography display={'flex'} alignItems={'center'} variant='body2'>{option.name}</Typography>
                            </Box>
                            {Boolean(option.price) && <Box mr={'16px'}>
                                <PriceRender price={option.price} color={'#FF7B2C'} />
                            </Box>}
                        </Box>
                        : <>{option.maxValue && option.maxValue > 1
                            ? <>
                                <Box display={'flex'} flexGrow={1}>
                                    <Typography display={'flex'} alignItems={'center'} variant='body2' px={'16px'}>{option.name}</Typography>
                                    {Boolean(option.price) && <Box mr={'16px'}>
                                        <PriceRender price={option.price} color={'#FF7B2C'} />
                                    </Box>}
                                </Box>
                                <Box
                                    display={'flex'}
                                    flexDirection={'row'}
                                    justifyContent={'center'}
                                    alignItems={'center'}
                                    sx={{ borderRadius: '16px', padding: '16px 20px' }}
                                >
                                    {option.value > 0 && <><IconButton
                                        size='small'
                                        sx={{ height: '32px', width: '32px', backgroundColor: '#fff2ea' }}
                                        disabled={option.value === 0}
                                        color='warning'
                                        onClick={() => {
                                            const newComponent = lodash.cloneDeep(category)
                                            newComponent.options.splice(index, 1, {
                                                ...option,
                                                value: option.value - 1
                                            })
                                            onComponentChange(newComponent)
                                        }}
                                    >
                                        <RemoveOutlinedIcon />
                                    </IconButton>
                                        <Box px='16px' justifyContent={'center'} flex='1' alignItems={'center'}>
                                            <Typography variant='body2' sx={{ lineHeight: '10px' }}>{option.value}</Typography>
                                        </Box>
                                    </>}
                                    <IconButton
                                        size='small'
                                        sx={{ height: '32px', width: '32px', backgroundColor: '#fff2ea' }}
                                        color='warning'
                                        disabled={option.value >= option.maxValue}
                                        onClick={() => {
                                            if (option.value < option.maxValue) { // safeguard against unintended button state change
                                                const newComponent = lodash.cloneDeep(category)
                                                newComponent.options.splice(index, 1, {
                                                    ...option,
                                                    value: option.value + 1
                                                })
                                                onComponentChange(newComponent)
                                            }
                                        }}
                                    >
                                        <AddOutlinedIcon />
                                    </IconButton>
                                </Box>
                            </>
                            : <Box
                                display='flex'
                                alignItems='center'
                                justifyContent='space-between'
                                flexGrow={1}
                                onClick={() => {
                                    const isCategoryFull = category.options.reduce((acc, item) => acc + item.value, 0) >= (Number(category.maxSelected))
                                    if (!isCategoryFull || (isCategoryFull && option.value === 1)) {
                                        const newComponent = lodash.cloneDeep(category)
                                        newComponent.options.splice(index, 1, {
                                            ...option,
                                            value: option.value === 1 ? 0 : 1
                                        })
                                        onComponentChange(newComponent)
                                        console.log('cat', newComponent)
                                    }

                                }}>
                                <Box
                                    display='flex'
                                    alignItems='center'
                                >
                                    <Checkbox
                                        checked={option.value === 1}
                                        disabled={true}
                                        sx={{
                                            color: 'silver',
                                            '&.Mui-checked': {
                                                color: '#FFB01D',
                                            },
                                        }} />
                                    <Typography display={'flex'} alignItems={'center'} variant='body2'>{option.name}</Typography>
                                </Box>
                                {Boolean(option.price) && <Box mr={'16px'}>
                                    <PriceRender price={option.price} color={'#FF7B2C'} />
                                </Box>}
                            </Box>
                        }</>
                    }</>
                </StyledPaper>)}
        </Box>)}
    </Box>
}

export default ItemComponentsByCategory